import { Link } from '@tanstack/react-router';
import { Ellipsis } from 'lucide-react';
import { Sheet } from '@kidova/ui-web';
import { useI18n } from '../i18n';
import { MORE } from './AppShell';

/** The bottom bar's "More" (§23.4): the pages that do not fit in its four tabs. */
export default function MoreSheet({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const { t } = useI18n();
  return (
    <Sheet
      title={t('nav.more')}
      open={open}
      onOpenChange={onOpenChange}
      trigger={
        <button type="button" className="app-tab-link" aria-haspopup="dialog">
          <Ellipsis size={22} strokeWidth={1.75} aria-hidden />
          <span>{t('nav.more')}</span>
        </button>
      }
    >
      <nav aria-label={t('nav.more')} className="flex flex-col gap-1">
        {MORE.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className="app-nav-link"
            onClick={() => {
              onOpenChange(false);
            }}
          >
            <item.icon size={20} strokeWidth={1.75} aria-hidden />
            <span>{t(item.label)}</span>
          </Link>
        ))}
        <Link to="/cancel" className="app-nav-link text-small">
          {t('nav.cancelContracts')}
        </Link>
      </nav>
    </Sheet>
  );
}
